import gsap, { Linear } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import TextPlugin from 'gsap/TextPlugin';
import Swiper, { Pagination } from 'swiper';
import { returnBlueprintAnimation, returnCoordinateAnimation } from '../app';

export default function initProjectSingle(isMobile, isTouch) {
  if (!document.querySelector('.project-single')) return;
  gsap.registerPlugin(ScrollTrigger, TextPlugin);

  if (document.querySelector('.project-single__hero--img .swiper')) {
    var heroSwiper = new Swiper('.project-single__hero--img .swiper', {
      modules: [Pagination],
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
  if (isMobile) {
    var blockquote = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.project-single__details--blockquote',
          start: 'top center',
        },
      })
      .from(
        '.project-single__details--blockquote svg, .project-single__details--blockquote blockquote',
        {
          x: '10vw',
          autoAlpha: 0,
        }
      )
      .from('.project-single__details--blockquote p', {
        x: '10vw',
        autoAlpha: 0,
      });

    var mockupScrub = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.project-single__details--mockup',
          start: 'bottom bottom',
          end: 'top top',
          scrub: true,
        },
      })
      .to('.project-single__details--mockup', {
        color: '#9e9e9e',
        borderColor: '#9e9e9e',
      })
      .to(
        '.project-single__details--mockup--spacer div',
        {
          backgroundColor: '#9e9e9e',
        },
        '<'
      );

    var gallery = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.project-single__details--gallery',
          start: 'top 80%',
        },
      })
      .from('.project-single__details--gallery img', {
        autoAlpha: 0,
        scale: 0.75,
        transformOrigin: 'center center',
        stagger: 0.1,
      });
  } else {
    if (isTouch) {
      var heroScrub = gsap.timeline({
        scrollTrigger: {
          trigger: '.project-single__hero',
          start: 'top top',
          end: '75% top',
          scrub: true,
        },
      });
      returnCoordinateAnimation(heroScrub, '.project-single__hero .coord');
      returnBlueprintAnimation(heroScrub, ".project-single__hero .bp");
      var detailsScrub = gsap.timeline({
        scrollTrigger: {
          trigger: '.project-single__details',
          start: 'top center',
          end: 'top top',
          scrub: true,
        },
      });
      returnCoordinateAnimation(
        detailsScrub,
        '.project-single__details--coord--1'
      );
      returnBlueprintAnimation(detailsScrub, ".project-single__details .bp");
      var blockquote = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.project-single__details--blockquote',
            start: 'top center',
          },
        })
        .from(
          '.project-single__details--blockquote svg, .project-single__details--blockquote blockquote',
          {
            x: '10vw',
            autoAlpha: 0,
          }
        )
        .from('.project-single__details--blockquote p', {
          x: '10vw',
          autoAlpha: 0,
        });

      var mockupScrub = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.project-single__details--mockup',
            start: 'bottom bottom',
            end: 'top top',
            scrub: true,
          },
        })
        .to('.project-single__details--mockup', {
          color: '#e0e0e0',
          borderColor: '#e0e0e0',
        })
        .to(
          '.project-single__details--mockup--spacer div',
          {
            backgroundColor: '#e0e0e0',
          },
          '<'
        );

      var gallery = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.project-single__details--gallery',
            start: 'top 80%',
          },
        })
        .from('.project-single__details--gallery img', {
          autoAlpha: 0,
          scale: 0.75,
          transformOrigin: 'center center',
          stagger: 0.1,
        });
    } else {
      var heroScrub = gsap.timeline({
        scrollTrigger: {
          trigger: '.project-single__hero',
          start: 'top top',
          end: 'bottom top',
          scrub: true,
        },
      });
      returnCoordinateAnimation(heroScrub, '.project-single__hero .coord');
      returnBlueprintAnimation(heroScrub, ".project-single__hero .bp");

      var detailsScrub = gsap.timeline({
        scrollTrigger: {
          trigger: '.project-single__details',
          start: 'top 75%',
          end: 'bottom top',
          scrub: true,
        },
      });
      returnCoordinateAnimation(
        detailsScrub,
        '.project-single__details--coord--1'
      );
      returnBlueprintAnimation(detailsScrub, ".project-single__details .bp");

      var blockquote = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.project-single__details--blockquote',
            start: 'top center',
          },
        })
        .from(
          '.project-single__details--blockquote svg, .project-single__details--blockquote blockquote',
          {
            x: '10vw',
            autoAlpha: 0,
          }
        )
        .from('.project-single__details--blockquote p', {
          x: '10vw',
          autoAlpha: 0,
        });

      var mockupScrub = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.project-single__details--mockup',
            start: 'bottom bottom',
            end: 'top top',
            scrub: true,
          },
        })
        .to('.project-single__details--mockup', {
          color: '#e0e0e0',
          borderColor: '#e0e0e0',
        })
        .to(
          '.project-single__details--mockup--spacer div',
          {
            backgroundColor: '#e0e0e0',
          },
          '<'
        );

      var gallery = gsap
        .timeline({
          scrollTrigger: {
            trigger: '.project-single__details--gallery',
            start: 'top 80%',
          },
        })
        .from('.project-single__details--gallery img', {
          autoAlpha: 0,
          scale: 0.75,
          transformOrigin: 'center center',
          stagger: 0.1,
        });
    }
  }
}
